import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';


import * as PD from '../classes/pdStyle';

import {cloneObject, getParam} from '../utils/utils';
import {formatDate, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";
import ViewConceptModel from "../components/ViewConceptModel";
import ViewMetadata from "../components/ViewMetadata";
import ListConcepts from "../components/ListConcepts";
import ListLinks from "../components/ListLinks";

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
///import ViewConceptModelVersion from "../components/ViewConceptModelVersion";
import ViewVersion from "../components/ViewVersion";
import {zipConceptModel} from "../utils/utilsConceptModel";
import { assetsConceptModelVersion } from "../utils/utilsConceptModel";

import { Reply } from "react-bootstrap-icons";


import Rendition from '../components/Rendition';


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import Buffering from "../components/Buffering";

import {getConceptModel, addConceptModel, editConceptModel} from '../utils/utilsConceptModel';

import JSZip from "jszip";

class ConceptModel extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
            loadData:false
        };


        this.data = {};
        this.viz = null;
        this.vizEngine = "dot";

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.handleExport = this.handleExport.bind(this);

        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);
        this.loadedConcepts = this.loadedConcepts.bind(this);
        this.loadedLinks = this.loadedLinks.bind(this);



        this.handleConceptFilters = this.handleConceptFilters.bind(this);
        this.handleLinkFilters = this.handleLinkFilters.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/conceptmodels`;


    }

    componentDidMount(){

       this.setup();

    }


    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadConceptModel(id){

        let StateChange = {};
        StateChange.ConceptModel = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.ConceptModel = data;

            StateChange.FormData = data;

            StateChange.renderState = "loaded";
            StateChange.isLoaded = true;

            if (this.context.hasLayout){
                this.context.Layout.setLeftAsConceptModel(data._id);
            }

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (StateChange.ConceptModel.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied"
                        StateChange.errorMessage = "You cannot edit this Concept Model"
                    break;
                }
            }


            // Update breadcrumb
            if (id){
                for (var i in window.Breadcrumb){
                    if (window.Breadcrumb[i][0] === 'conceptmodel'){
                        window.Breadcrumb = window.Breadcrumb.slice(0,i);
                        break;
                    }
                }
                this.Breadcrumb = JSON.parse(JSON.stringify(window.Breadcrumb));
    
                window.Breadcrumb.push(['concept model',`/conceptmodel/${id}`]);

                this.FallBackNavigation = `../conceptmodels`;
                this.onUpdateNavigation = this.FallBackNavigation;
            }

            this.fetchViz(id);

            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.ConceptModel = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getConceptModel(this.dsd, id, onLoad, onFail);
        }

        this.setState(StateChange);

        return;
        
    };


    async loadVersionAssets(id, idVersion){

        if (!id || !idVersion === null){
            return;
        }

        this.setState({ renderState: 'loading' });

        const assets = await assetsConceptModelVersion(this.dsd, id, idVersion);

        this.setState({
            mdVersionPage: assets["page.md"],
            VersionAssets: assets,
            isLoaded: true,
            renderState: 'loaded'
        });

        return;
        
    };


    fetchViz(id) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getConceptModel(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };
    

    setup(){


        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            errorMessage: null,
            renderState: null,

            OfferEdit: false,

            FormData: {},
            Controls: {
                vizLinkedModels: false
            },

            ConceptFilters: {
                status:'in use'
            },
            LinkFilters: {
                status:'in use'
            },

            idConceptModel: null,

            ConceptModel: null,
            Concepts: null,
            Links: null,

            idVersion: null,

            action: null,

            updateToggle: 0,

            countVersions: null,
            countConcepts: null,
            countLinks: null,

            dot: null

        }

        StateChange.mode = getParam('mode', this.props);

        StateChange.idConceptModel = getParam('id', this.props);

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        StateChange.idVersion = getParam('idVersion', this.props);

        this.setState(StateChange, async () => {

            if (this.state.idVersion){
                await this.loadVersionAssets(this.state.idConceptModel, this.state.idVersion);
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsConceptModelVersions(this.state.idConceptModel);
                }
                return;
            }

            if (this.state.idConceptModel){
                this.loadConceptModel(this.state.idConceptModel);
            }

        });
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;        
        this.setState({"FormData": FormData});

        return;

    };
    

    handleConceptFilters(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let ConceptFilters = this.state.ConceptFilters;
        ConceptFilters[FormFieldName] = FormFieldValue;
        this.setState({"ConceptFilters": ConceptFilters});

        return;

    };


    handleLinkFilters(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let LinkFilters = this.state.LinkFilters;
        LinkFilters[FormFieldName] = FormFieldValue;
        this.setState({"LinkFilters": LinkFilters});

        return;

    };



    handleSubmit(event) {

        const onError = function(e){
            let StateChange = {};
            StateChange.isFailed = true;
            StateChange.errorMessage = e.message;

            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                    if (e.response.data.fields){
                        StateChange.invalidFields = e.response.data.fields
                    }

                }
            }

            this.setState(StateChange);
            return;
        }.bind(this);

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':

                switch (this.state.mode){
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                    case 'edit':
                        this.props.navigation(`/conceptmodel/${this.state.idConceptModel}`);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    invalidFields: false
                })
        
                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(idConceptModel){
                            this.props.navigation(`/conceptmodel/${idConceptModel}`);
                            return;
                        }.bind(this);

                        addConceptModel(this.dsd, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/conceptmodel/${this.state.idConceptModel    }`);
                            return;
                        }.bind(this);

                        editConceptModel(this.dsd, this.state.idConceptModel, this.state.FormData, onUpdate, onError);

                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
            case 'btnAddConcept':
                this.props.navigation(`/conceptmodel/${this.state.idConceptModel}/concept?mode=new`);
                break;
            case 'btnAddLink':
                this.props.navigation(`/conceptmodel/${this.state.idConceptModel}/link?mode=new`);

                break;
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    handleAddVersion(event) {

        this.setState({newVersion:true});

    }


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'concept':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/concept/${partsVizNodeId[1]}`);
                    }
                    break;
            }
        }

        event.preventDefault();

    };

    log(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.ConceptModel){
            return null;
        }

        let arrLog = [];
        for (let pos=0;pos<this.state.ConceptModel.Concepts.length;pos++){
            let Concept = this.state.ConceptModel.Concepts[pos];
            if (Concept.createdAt){
                let LogEntry = {};
                LogEntry.date = Concept.createdAt;
                LogEntry.action = 'created';
                LogEntry.subjectType = 'Concept';
                LogEntry.Subject = Concept;
                LogEntry.name = Concept.name;
                LogEntry.link = `/concept/${Concept._id}`;
                arrLog = this.insertLog(arrLog, LogEntry);
            }
            if (Concept.Revisions){
                for (let posR=0; posR<Concept.Revisions.length;posR++){
                    let Revision = Concept.Revisions[posR];
                    if (Revision.report){
                        let LogEntry = {};
                        LogEntry.date = Revision.createdAt;
                        LogEntry.action = 'revised';
                        LogEntry.subjectType = 'Concept';
                        LogEntry.Subject = Concept;
                        LogEntry.name = Concept.name;
                        LogEntry.link = `/concept/${Concept._id}`;
                        LogEntry.Revision = Revision
                        LogEntry.description = Revision.description;
                        arrLog = this.insertLog(arrLog, LogEntry);
                    }
                }
            }
        }

        for (let pos=0;pos<this.state.ConceptModel.Links.length;pos++){
            let Link = this.state.ConceptModel.Links[pos];
            if (Link.createdAt){
                let LogEntry = {};
                LogEntry.date = Link.createdAt;
                LogEntry.action = 'created';
                LogEntry.subjectType = 'Link';
                LogEntry.Subject = Link;
                LogEntry.name = Link.name;
                LogEntry.link = `/link/${Link._id}`;
                arrLog = this.insertLog(arrLog, LogEntry);
            }
            if (Link.Revisions){
                for (let posR=0; posR<Link.Revisions.length;posR++){
                    let Revision = Link.Revisions[posR];
                    if (Revision.report){
                    let LogEntry = {};
                        LogEntry.date = Revision.createdAt;
                        LogEntry.action = 'revised';
                        LogEntry.subjectType = 'Link';
                        LogEntry.Subject = Link;
                        LogEntry.name = Link.name;
                        LogEntry.link = `/link/${Link._id}`;
                        LogEntry.Revision = Revision
                        LogEntry.description = Revision.description;
                        arrLog = this.insertLog(arrLog, LogEntry);                       
                    }
                }
            }
        }

        if (!arrLog.length){
            return null;
        }

        return (
            <PD.Table>
                <PD.Thead>
                    <PD.Tr>
                        <PD.Th>on</PD.Th>
                        <PD.Th>what</PD.Th>
                        <PD.Th>name</PD.Th>
                        <PD.Th>change</PD.Th>
                        <PD.Th>description</PD.Th>
                    </PD.Tr>
                </PD.Thead>

                <PD.Tbody>
                    {
                        arrLog.map(
                        (entry, pos) => 
                            {
                                return (
                                    <PD.Tr key={pos}>
                                        <PD.Td>{formatDate(entry.date,'dmy')}</PD.Td>
                                        <PD.Td>{entry.subjectType}</PD.Td>
                                        <PD.Td>
                                            <PD.PdNavLink to={entry.link} >{entry.name}</PD.PdNavLink>
                                        </PD.Td>
                                        <PD.Td>{entry.action}</PD.Td>
                                        <PD.Td>{formatText(truncate(entry.description, 400))}</PD.Td>
                                    </PD.Tr>
                                )
                            }
                        )
                    }
                </PD.Tbody>
            </PD.Table>

        )


    }

    insertLog(array, entry){

        let boolInserted = false;

        let newArray = [];

        for (let pos=0; pos<array.length;pos++){
            if (!boolInserted){
                if (entry.date < array[pos].date){
                    newArray.push(entry);
                    boolInserted = true;
                }
            }
            newArray.push(array[pos]);
        }

        if (!boolInserted){
            newArray.push(entry);
        }

        return newArray;

    }

    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.ConceptModel){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idConceptModel} type='conceptmodel' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idConceptModel}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
       this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }

    loadedConcepts(count){

        let StateChange = {};

        StateChange.countConcepts = 0;
        if (count){
            StateChange.countConcepts = count;
        }

        this.setState(StateChange);

    }

    loadedLinks(count){

        let StateChange = {};

        StateChange.countLinks = 0;
        if (count){
            StateChange.countLinks = count;
        }

        this.setState(StateChange);

    }

    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let idConceptModel = this.state.idConceptModel;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipConceptModel(this.dsd, idConceptModel, idVersion);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `conceptmodel_${idConceptModel}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }

    }


    visualise(){
    
        if (!this.state.ConceptModel){
            return <Buffering/>;
        }

        const onChangeVizControl = function(event){

            const FormFieldName = event.target.name;
            let FormFieldValue = event.target.value;

            if (event.target.type == "checkbox"){
                FormFieldValue = event.target.checked;
            }

            let Controls = this.state.Controls;
            Controls[FormFieldName] = FormFieldValue;
            this.setState({Controls:Controls}, () => {
                this.fetchViz(this.state.idConceptModel);
            });
        }.bind(this);


        try {

            return(
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <PD.Checkbox label="Linked Models?" name="vizLinkedModels" value={this.state.Controls.vizLinkedModels} onChange={onChangeVizControl}/>                    
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.state.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    showError(){


        if (this.state.invalidFields){
            return(
                <>
                    {
                        Object.keys(this.state.invalidFields).map(
                        (field, pos) => 
                            {
                                let error = this.state.invalidFields[field].error;
                                return <p key={pos}>{field}:{error}</p>
                            }
                        )
                    }
                </>
            )
        }

        return "ERROR - Failed to Update";

    }

    render() {

        // Handle render states for loading, errors, etc.
        switch (this.state.renderState){
            case "loading":
                return <Buffering/>
            case "failed":
            case "denied":
                let Message = "An error has occurred";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
        }

        if (this.state.isUpdated){
            switch (this.state.mode){
                case 'remove':
                    this.props.navigation(this.FallBackNavigation);
                    return null;
                default:
                    break;
            };
        };

        if (this.state.idVersion){
//                return(
//                    <ViewNarrativeVersion idVersion={this.state.idVersion} idNarrative={this.state.idNarrative}/>
//                )

            return(
                <div>
                    <PD.Button onClick={ () => this.props.navigation(`/conceptmodel/${this.state.idConceptModel}`) } value="back"><Reply/></PD.Button>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                    <ViewVersion mdPage={this.state.mdVersionPage} assets={this.state.VersionAssets} idVersion={this.state.idVersion}/>
                </div>
            )

        }

/*
        // Handle viewing a specific version
        if (this.state.idVersion){
            return(
                <ViewConceptModelVersion idConceptModel={this.state.idConceptModel} idVersion={this.state.idVersion}/>
            )
        }
*/
        // Handle new mode without data
        if (this.state.mode === 'new'){
            return (
                <div>

                    <PD.Heading>{this.state.mode} Concept Model</PD.Heading>

                    {this.state.isFailed &&
                        <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                    }

                    <form> 
                        <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                        <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>

                        <PD.Input label="Namespace" width="30" name="namespace" value={this.state.FormData.namespace} onChange={this.handleChange}/>
                        <PD.Input label="Default Prefix" width="10" name="prefix" value={this.state.FormData.prefix} onChange={this.handleChange}/>

                        <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                        <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                            {
                                this.dsd.config.ComponentStatuses.map(
                                    (status, posStatus) => 
                                        {
                                            return(
                                                <option key={posStatus} value={status}>{status}</option>
                                            )
                                        }
                                )
                            }
                        </PD.Select>

                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                    </form>

                </div>    
            );
        }

        // For view and edit modes, we need the ConceptModel loaded
        if (this.state.renderState === 'loaded' && this.state.ConceptModel) {

            switch (this.state.mode){
                case 'edit':

                    return (
                    <div>

                        <PD.Heading>{this.state.mode} Concept Model</PD.Heading>
    
                        {this.state.isFailed &&
                            <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                        }

                        <form> 
                            <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                            <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>

                            <PD.Input label="Namespace" width="30" name="namespace" value={this.state.FormData.namespace} onChange={this.handleChange}/>
                            <PD.Input label="Default Prefix" width="10" name="prefix" value={this.state.FormData.prefix} onChange={this.handleChange}/>

                            <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                            <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                {
                                    this.dsd.config.ComponentStatuses.map(
                                        (status, posStatus) => 
                                            {
                                                return(
                                                    <option key={posStatus} value={status}>{status}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>

                            <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                            <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                        </form>
    
                    </div>    
                    );
                case 'remove':
                    return (
                        <div>
                            <PD.Heading>{this.state.mode} Concept Model</PD.Heading>

                            {this.state.isFailed &&
                                <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                            }

                            <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                            <ViewConceptModel ConceptModel={this.state.ConceptModel}/>
                        </div>
                    )
                case 'view':
                default:

                    return (
                        <div>
                            <div>
                                <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                <PD.Heading>Concept Model:{this.state.ConceptModel.name}</PD.Heading>
                            </div>

                            {this.state.OfferEdit &&
                                <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />
                                </span>
                            }

                            <ViewConceptModel ConceptModel={this.state.ConceptModel}/>

                            <br/>

                            <PD.Tabs>

                                <div label='Visualise'>
                                    {this.visualise()}
                                </div>

                                <div label={<span>Concepts({this.state.countConcepts === null ? <Buffering/> : this.state.countConcepts})</span>}  data-forcerender="true">
                                    <>
                                        <div style={{display:"flex"}}>
                                            {this.state.OfferEdit && 
                                                <PD.Button name='btnAddConcept' value='add a new Concept' onClick={this.handleButton}/>
                                            }
                                            <fieldset style={{display:"flex"}}>
                                                <legend>filters</legend>
                                                <PD.Select label='status' name='status'  onChange={this.handleConceptFilters} value={this.state.ConceptFilters.status}>
                                                    {
                                                        this.dsd.config.ConceptStatuses.map(
                                                            (status, posStatus) => 
                                                                {
                                                                    return(
                                                                        <option key={posStatus} value={status}>{status}</option>
                                                                    )
                                                                }
                                                        )
                                                    }
                                                </PD.Select>
        
                                            </fieldset>
                                        </div>
                                        <ListConcepts filters={{idConceptModel:this.state.idConceptModel, ...this.state.ConceptFilters}} onLoad={this.loadedConcepts} />
                                    </>
                                </div>

                                <div label={<span>Links({this.state.countLinks === null ? <Buffering/> : this.state.countLinks})</span>}  data-forcerender="true">
                                    <>
                                        <div style={{display:"flex"}}>
                                            {this.state.OfferEdit && 
                                                <PD.Button name='btnAddLink' value='add a new Link' onClick={this.handleButton}/>
                                            }
                                            <fieldset style={{display:"flex"}}>
                                                <legend>filters</legend>
                                                <PD.Select label='status' name='status'  onChange={this.handleLinkFilters} value={this.state.LinkFilters.status}>
                                                    {
                                                        this.dsd.config.LinkStatuses.map(
                                                            (status, posStatus) => 
                                                                {
                                                                    return(
                                                                        <option key={posStatus} value={status}>{status}</option>
                                                                    )
                                                                }
                                                        )
                                                    }
                                                </PD.Select>
        
                                            </fieldset>
                                        </div>
                                        <ListLinks filters={{idConceptModel:this.state.idConceptModel, ...this.state.LinkFilters}} onLoad={this.loadedLinks} />
                                    </>
                                </div>

                                <div label='Log'>
                                    {this.log()}
                                </div>
                                    
                                <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                    {this.versions()}
                                </div>


                                <div label='Developer'>
                                    <Rendition
                                        endpoint="/conceptmodels"
                                        id={this.state.idConceptModel}
                                    />
                                </div>


                                <div label='Metadata'>
                                    <ViewMetadata Data={this.state.ConceptModel} />
                                </div>


                            </PD.Tabs>


                        </div>
                    )
            }
        }

        return <div />;
    };
};

// Wrap and export
export default function ConceptModel_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ConceptModel {...props} navigation={navigation} location={location} params={params} />;
  }
